import { baseApi } from "./api"

export const userApi = baseApi.enhanceEndpoints({ addTagTypes: ['Login'] }).injectEndpoints({
    endpoints: (builder) => ({
        // -- Login User --
        loginEmail: builder.mutation({
            query: (email) => ({
                url: 'user/email/send',
                method: 'POST',
                body: {email},
            }),
        }),
        loginEmailVerify: builder.mutation({
            query: (token) => ({
                url: 'user/email/verify',
                method: 'POST',
                body: {token},
            }),
            invalidatesTags: (result, error, arg) => error?[]:[{ type: 'Login', id: 'LOGIN' }],
        }),
        getLogin: builder.query({
            query: () => ({
                url: 'user/verify',
                method: 'GET',
            }),
            providesTags: (result, error, arg) => [{ type: 'Login', id: 'LOGIN' }],
        }),
        logout: builder.mutation({
            query: () => ({
                url: 'user/logout',
                method: 'GET',
            }),
            invalidatesTags: (result, error, arg) => error?[]:[{ type: 'Login', id: 'LOGIN' }],
        }),
    }),
})

export const {
    useLoginEmailMutation,
    useLoginEmailVerifyMutation,
    useGetLoginQuery,
    useLogoutMutation,
} = userApi;